import $ from 'jquery'
import Isotope from 'isotope-layout'
import { debounce, getTextNodesIn } from '../functions'

const object = vnObject;

var blogIsoElement = document.querySelector('.js-posts');

if (blogIsoElement) {
    var blogIso = new Isotope(blogIsoElement, {
        itemSelector: '.js-iso-item',
        transitionDuration: 0,
    });
}

var currentBlogSearch = '';
var currentBlogCat = '';

const search = $('.js-blog-search').keyup(
    debounce(function () {
        const qsRegex = new RegExp(search.val(), 'gi');
        currentBlogSearch = qsRegex;

        blogSearch();
    }, 200)
);

search.on('blur', function () {
    const qsRegex = new RegExp(search.val(), 'gi');
    currentBlogSearch = qsRegex;

    blogSearch();
});

const blogInput = $('.js-blog-select');

blogInput.on('change', function () {
    const catId = $(this).val();
    currentBlogCat = catId;

    blogSearch();
});

function blogSearch() {
    let hiddenItems = 0;
    const maxItemsToShow = 10;

    blogIso.arrange({
        filter: function () {
            const post = $(this);
            const text = getTextNodesIn(post[0]);
            let hasText = currentBlogSearch ? text.match(currentBlogSearch) : true;

            let catMatched = true;
            let cats = post.attr('data-categories').split(',');

            if (currentBlogCat != '' && cats) {
                if (cats.indexOf(currentBlogCat.toString()) == -1) {
                    catMatched = false;
                }
            }

            const shouldDisplay = hasText && catMatched;

            if (shouldDisplay) {
                if (hiddenItems < maxItemsToShow) {
                    post.removeClass('hidden').css('display', 'block');
                    hiddenItems++;
                } else {
                    post.addClass('hidden').css('display', 'none');
                }
            } else {
                post.addClass('hidden').css('display', 'none');
            }

            return shouldDisplay;
        },
    });

    // Show or hide "Load More" button depending on the number of visible items
    if ($('.js-posts .js-iso-item.hidden').length === 0) {
        $('#load-more').hide();
    } else {
        $('#load-more').show();
    }
}

document.addEventListener('DOMContentLoaded', function () {
    let loadMoreBtn = document.getElementById('load-more');
    let posts = document.querySelectorAll('.js-posts .hidden');
    let itemsToShow = 10;
    let currentIndex = 0;

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
            for (let i = currentIndex; i < currentIndex + itemsToShow && i < posts.length; i++) {
                posts[i].style.display = 'block';
                posts[i].classList.remove('hidden');
            }
            currentIndex += itemsToShow;

            if (currentIndex >= posts.length) {
                loadMoreBtn.style.display = 'none';
            }
        });
    }
});
